import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {liteTemplate} from "@/lib/routes";

const defaultSetRoute = {
    track: (route, router, unitId, date) => {
        if(consts.app.$isDevelopment) console.warn('defaultSetRoute track empty', unitId, date);
    },
    trackParams: (route, router, date, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackParams', route);
            return false
        }
        date = date || route?.params?.date || store.getters.getDateToday
        let unit = store.getters.getUnitsByIds[unitId]
        let name = consts.routerNames.tracks.unit.main
        if(consts.typesForTrackByPoints.includes(unit?.type)) {
            name = consts.routerNames.tracks.unit.asset.main
        }
        if(unitId) {
            router.push({
                name,
                params: {
                    unitId,
                    date
                },
                query: {...route.query}
            })
        } else {
            router.push({
                name: consts.routerNames.tracks.date,
                params: {
                    date
                },
                query: {...route.query}
            })
        }

    },
    trackXid: (route, router, type, trackXid, timeFrom, timeTo, trackColor) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: consts.routerNames.tracks.xid,
            params: {
                unitId,
                date,
                type,
                trackXid,
                timeFrom,
                timeTo,
                trackColor,
            },
            query: {...route.query}
        })
    },
    drivingAssetIndex: (route, router, index) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        router.push({
            name: consts.routerNames.tracks.unit.asset.index,
            params: {
                ...route.params,
                index: index,
            },
            query: {...route.query}
        })
    },
    trackColor: (route, router, trackColor) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: route.name,
            params: {
                ...route?.params,
                trackColor,
            },
            query: {...route.query}
        })
    },
    trackEvent: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackEvent', route);
            return false
        }
        router.push({
            name: consts.routerNames.tracks.event_xid,
            params: {
                ...route.params,
                trackEventType,
                trackEventXid,
            },
            query: {...route.query}
        })
    },
    trackMoveOnTrack: (route, router, speed) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        let params = {...route?.params}
        if(speed) {
            params.speed = speed
        } else if(params.speed) {
            delete params.speed
        }
        router.push({
            name: route.name,
            params,
            query: {...route.query}
        })
    },
    trackVideoEventPopup: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackVideoEventPopup', route);
            return false
        }
        router.push({
            name: consts.routerNames.tracks.video.event,
            params: {
                ...route.params,
                trackEventType,
                trackEventXid,
            },
        })
    },
    trackVideoRequestPopup: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackVideoEventPopup', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let type = route?.params?.type
        let trackId = route?.params?.trackXid
        router.push({
            name: consts.routerNames.tracks.video.request,
            params: {
                unitId,
                date,
                type,
                trackId,
                trackEventType,
                trackEventXid,
            },
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.tracks.main+' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.tracks.main;
        router.push({
            name: name ,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
    liteTemplate,
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'tracks/:pathMatch(.*)?/:noList(no-list)?/:lite(lite)?',
        name: consts.routerNames.tracks.main,
        redirect: {
            name: consts.routerNames.tracks.date,
            params: {
                date: store.getters.getDateToday,
            }
        },
        meta: {
            list: 'TracksList',
            mainRouteName: consts.routerNames.tracks.main,
            showMapInfo: true,
            showMap: true,
            isLimited: false,
            layers: {
                ...consts.defaultSettingsLayers,
                geoitems: {visible: false, showInList: true, showLayer: true},
                tracks: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/intuit/portal/TracksPage.vue'),
        children:[
            {
                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                name: consts.routerNames.tracks.date,
                children: [
                    {
                        path: ':unitId(\\d+)',
                        name: consts.routerNames.tracks.unit.main,
                        children: [
                            {
                                path: 'asset',
                                name: consts.routerNames.tracks.unit.asset.main,
                                meta: {
                                    layers: {
                                        ...consts.defaultSettingsLayers,
                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                        tracks: {visible: false, showInList: false, showLayer: false},
                                        track_by_points: {visible: true, showInList: false, showLayer: true},
                                    },
                                },
                                children: [
                                    {
                                        path: ':index',
                                        name: consts.routerNames.tracks.unit.asset.index,
                                        meta:{
                                            mainRouteName: consts.routerNames.tracks.main,
                                            parentRouteName: consts.routerNames.tracks.unit.asset.main,
                                        },
                                    },
                                ]
                            },
                            {
                                path: ':type(parking|driving)/:trackXid/:timeFrom(\\d+)/:timeTo(\\d+)/:trackColor(track-color)?/:speed(\\d+)?',
                                name: consts.routerNames.tracks.xid,
                                meta:{
                                    mainRouteName: consts.routerNames.tracks.main,
                                    parentRouteName: consts.routerNames.tracks.main,
                                },
                                // props: {
                                // },
                                // components: {
                                // }
                                children:[
                                    {
                                        path: ':trackEventType/:trackEventXid',
                                        name: consts.routerNames.tracks.event_xid,
                                        meta:{
                                            mainRouteName: consts.routerNames.tracks.main,
                                            parentRouteName: consts.routerNames.tracks.xid,
                                        },
                                        // props: {
                                        // },
                                        // components: {
                                        // }
                                        children: [
                                            {
                                                path: 'video-event-popup',
                                                name: consts.routerNames.tracks.video.event,
                                                meta:{
                                                    mainRouteName: consts.routerNames.tracks.main,
                                                    parentRouteName: consts.routerNames.tracks.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'events'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            },
                                            {
                                                path: 'video-request-popup',
                                                name: consts.routerNames.tracks.video.request,
                                                meta:{
                                                    mainRouteName: consts.routerNames.tracks.main,
                                                    parentRouteName: consts.routerNames.tracks.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'requests'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            }
                                        ]
                                    },
                                ]
                            },
                        ]
                    },
                ]
            },
        ]
    },
];

export default routes;